import { render, staticRenderFns } from "./menu_inserimento_qta_mobile.vue?vue&type=template&id=1a2f8ea3&scoped=true&"
import script from "./menu_inserimento_qta_mobile.vue?vue&type=script&lang=js&"
export * from "./menu_inserimento_qta_mobile.vue?vue&type=script&lang=js&"
import style0 from "./menu_inserimento_qta_mobile.vue?vue&type=style&index=0&id=1a2f8ea3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2f8ea3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBadge,VBottomSheet,VBtn,VCard,VCardText,VCardTitle,VCol,VIcon,VImg,VProgressCircular,VRow,VSpacer,VTextField})
